export const sharedNextPage = (page, params, history) => {
    try {
        // const history = useHistory();
        // history.push(`${page}`);
        // console.log('params');
        // console.log(params);
        if (params !== undefined && params !== null) {
            if (params.acciones !== undefined) {
                delete params.acciones;
            }
            // console.log('params sin acciones');
            // console.log(params);
            history.push({
                pathname: `${page}`,
                state: params
            });
        } else {
            history.push(`${page}`);
        }
    } catch (err) {
        console.log('nextPage err');
        console.log(err);
    }
};

export const sharedOpenNewTab = (page, params) => {
    try {
        // Open the new page in a new tab
        const newWindow = window.open(page, '_blank');

        // Wait until the new page is fully loaded, then send the data
        newWindow.onload = () => {
            console.log('onload');
            newWindow.postMessage(params, window.location.origin);
        };
    } catch (err) {
        console.log('sharedNextPage error:', err);
    }
};

export const getWeekStartAndEnd = () => {
    const today = new Date();

    // Get the start of the week (Sunday as the first day)
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay());

    // Get the end of the week (Saturday as the last day)
    const endOfWeek = new Date(today);
    endOfWeek.setDate(today.getDate() + (6 - today.getDay()));

    // Format to YYYY-MM-DD
    const startDate = startOfWeek.toISOString().split("T")[0];
    const endDate = endOfWeek.toISOString().split("T")[0];

    return { startDate, endDate };
};

export const procesarCampo = (index, valorDefault, keyConstante, combo, columnas) => {
    const parsed = JSON.parse(valorDefault);
    if (index !== -1 && parsed !== null) {
        combo.push(parsed);
        columnas[`${keyConstante}`] = { valorCombo: parsed };
    }
};

export const agregarCampoConfiguracion = (obj, columnas, keyEnum, nombreCampo) => {
    const campo = columnas[`${keyEnum}`];
    obj[`index${nombreCampo}`] = -1;
    obj[`valorDefault${nombreCampo}`] = null;

    if (campo !== undefined && campo !== null) {
        obj[`index${nombreCampo}`] = campo.valorCombo.value;
        obj[`valorDefault${nombreCampo}`] = {
            value: campo.valorCombo.value,
            label: campo.valorCombo.label
        };
    }
};

export const exportarLink = (urlDescarga, nombreArchivo) => {
    try {

        const link = document.createElement('a');
        link.href = urlDescarga;
        link.target = '_blank';
        link.setAttribute(
            'download',
            nombreArchivo,
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        //      });
    } catch (err) {
        console.log('exportarLink err');
        console.log(err);
    }
};

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

